module.exports = __webpack_public_path__ + "static/media/font_medium.b1da0862.woff";